export default "__VITE_ASSET__Cd7m0gIn__"